import { render, staticRenderFns } from "./PayrollReceiptsTable.vue?vue&type=template&id=b3af0784&scoped=true"
import script from "./PayrollReceiptsTable.vue?vue&type=script&lang=js"
export * from "./PayrollReceiptsTable.vue?vue&type=script&lang=js"
import style0 from "./PayrollReceiptsTable.vue?vue&type=style&index=0&id=b3af0784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3af0784",
  null
  
)

export default component.exports